module.exports = __webpack_public_path__ + "img/Archive.904b5e30.svg";